import EventEmitter from "events";
import commonFn from "@/commons/commonFunction";
import store from "@/stores/store";
import { ModuleContext } from "@/stores/moduleConst";
import indexedDB from '@/commons/indexedDB';

// import axios, { Cancel } from 'axios';
// import qs from 'querystring';
// import commonFn from '@/commons/commonFunction';
// import apiConfig from '@/apis/apiConfig';
// import router from '../router';
// import store from '@/stores/store';
// import { MSEnum } from '@/commons/enumeration';
// import { removeStorage } from '../stores/vuex-persistance-plugin';
// import { isNullOrEmpty } from '../commons/objectUtil';
// import {
// 	ModuleCompany,
// 	ModuleAuth,
// 	ModuleDictionary,
// 	ModuleTaxPayerInfo,
// 	ModuleLicenseInfo,
// 	ModuleOptions
// } from '../stores/moduleConst';

// // 'loggedIn' is used in other parts of application. So, Don't forget to change there also
// const loginEventKey = 'loginEvent';
// const userInfo = 'userInfo';

class AuthService extends EventEmitter {
  // 	constructor() {
  // 		super();
  // 		axios.interceptors.response.use(
  // 			response => {
  // 				return response;
  // 			},
  // 			error => {
  // 				if (
  // 					error &&
  // 					error.response &&
  // 					error.response.status ==
  // 						MSEnum.StatusCode.Status403Forbidden
  // 				) {
  // 					if (
  // 						error.response.data.Code ==
  // 						MSEnum.ServiceStatusCode.Status06NotPermittedAccess
  // 					) {
  // 						//Không có quyền truy cập
  // 						router.push('/login/startwithtaxcode');
  // 						store.commit(`${ModuleCompany}/updateCompanyInfo`, {});
  // 					} else if (
  // 						error.response.data.Code ==
  // 						MSEnum.ServiceStatusCode.Status11InvalidAdminAccess
  // 					) {
  // 						//Không có quyền admin
  // 						router.push('/pages/not-permission');
  // 					} else if (
  // 						error.response.data.Code ==
  // 						MSEnum.ServiceStatusCode.Status27MaintainSystem
  // 					) {
  // 						//Đang bảo trì
  // 						router.push('/pages/maintancesystem');
  // 					}
  // 				} else if (
  // 					error &&
  // 					error.response &&
  // 					error.response.status ==
  // 						MSEnum.StatusCode.Status401Unauthorized
  // 				) {
  //
  // 					router.push('/login');
  // 					this.logOut();
  // 				} else {
  // 					if (error instanceof Cancel) {
  // 						//Cancel request của dịch vụ nên không xử lý gì
  // 						console.log('Cancel request!');
  // 					} else {
  // 						return Promise.reject(error);
  // 					}
  // 				}
  // 			}
  // 		);
  // 	}

  // 	/**
  // 	 * Điều hướng sang màn đăng nhập
  // 	 * @param {*} userInfo
  // 	 */
  // 	logoutExternal(userInfo) {
  // 		window.location = location.origin + '/login';
  // 	}

  // 	/**
  // 	 * Cập nhật thông tin người dùng, công ty xuống State
  // 	 * Lấy thông tin người nộp thuế
  // 	 * Lấy thông tin license
  // 	 * Điều hướng sang màn Chọn MST làm việc nếu chưa có MST mặc định, ngoài ra cho vào Dashboard	 *
  // 	 * @param {*} data
  // 	 */
  // 	localLogin(data) {
  // 		let me = this;

  // 		// Cập nhật thông tin đăng nhập của MISAID
  // 		store.commit(`${ModuleAuth}/updateMisaToken`, {
  // 			misaAccessToken: data.AccessToken,
  // 			misaExpire: data.ExpiresIn,
  // 			misaRefreshToken: data.RefreshToken,
  // 			LinkSignalR: data.AppData.LinkSignalR,
  // 			RunSignalR: data.AppData.RunSignalR
  // 		});

  // 		// Cập nhật thông tin đăng nhập của Mtax
  // 		store.commit(`${ModuleAuth}/updateAccessToken`, data.AppData);

  // 		// Kiểm tra thông tin người dùng xem đã làm việc với mã số thuế nào chưa?
  // 		if (
  // 			data.AppData.User &&
  // 			data.AppData.User.TaxCodeWorking &&
  // 			data.AppData.RoleUser &&
  // 			data.AppData.RoleUser.IsActive
  // 		) {
  // 			// Cập nhật thông tin công ty
  // 			store.commit(
  // 				`${ModuleCompany}/updateCompanyInfo`,
  // 				data.AppData.RoleUser
  // 			);

  // 			// Cập nhật lại license
  // 			store.commit(
  // 				`${ModuleLicenseInfo}/updateLicenseInfo`,
  // 				data.AppData.LicenseInfo
  // 			);

  // 			//Cập nhật thông tin người nộp thuế
  // 			store.commit(
  // 				`${ModuleTaxPayerInfo}/setTaxPayerInfo`,
  // 				data.AppData.TaxPayerInfo
  // 			);

  // 			//Cập nhật thông tin tùy chọn của hệ thống
  // 			store.commit(
  // 				`${ModuleOptions}/updateOptionsData`,
  // 				data.AppData.OptionsData
  // 			);

  // 			setTimeout(() => {
  // 				router.push('/');
  // 			}, 500);
  // 		} else {
  // 			router.push('/login/startwithtaxcode');
  // 		}
  // 	}

  // 	localLoginIntegration(data) {
  // 		let me = this;

  // 		// Cập nhật thông tin đăng nhập của MISAID
  // 		store.commit(`${ModuleAuth}/updateMisaToken`, {
  // 			misaAccessToken: data.AccessToken,
  // 			misaExpire: data.ExpiresIn,
  // 			misaRefreshToken: data.RefreshToken,
  // 			LinkSignalR: data.AppData.LinkSignalR,
  // 			RunSignalR: data.AppData.RunSignalR
  // 		});

  // 		// Cập nhật thông tin đăng nhập của Mtax
  // 		store.commit(`${ModuleAuth}/updateAccessToken`, data.AppData);

  // 		// Cập nhật thông tin công ty
  // 		store.commit(
  // 			`${ModuleCompany}/updateCompanyInfo`,
  // 			data.AppData.RoleUser
  // 		);

  // 		// Cập nhật lại license
  // 		store.commit(
  // 			`${ModuleLicenseInfo}/updateLicenseInfo`,
  // 			data.AppData.LicenseInfo
  // 		);

  // 		//Cập nhật thông tin người nộp thuế
  // 		store.commit(
  // 			`${ModuleTaxPayerInfo}/setTaxPayerInfo`,
  // 			data.AppData.TaxPayerInfo
  // 		);

  // 		//Cập nhật thông tin tùy chọn của hệ thống
  // 		store.commit(
  // 			`${ModuleOptions}/updateOptionsData`,
  // 			data.AppData.OptionsData
  // 		);
  // 	}

  // 	//Đăng xuất xóa phiên đăng nhập
  // 	logOut() {
  // 		//Xóa thông tin trong local storage
  // 		removeStorage();
  // 		//Điều hướng sang màn đăng nhập
  // 		this.logoutExternal(userInfo);
  // 	}

  //Kiểm tra xem còn session đăng nhập ko
  isAuthenticated() {
    //check amissession có thay đổi không
    const amisSessionKey = "asid",
      curAID = window._aside || '',
      lastAID = commonFn.getLocalStorage(amisSessionKey) || '';

    if (lastAID != curAID) {
      console.log('Amis session changed', lastAID, curAID);
      
      this.clearLoginData();
      commonFn.setLocalStorage(amisSessionKey, curAID);
      return false;
    }

    //nếu hợp lệ kiểm tra phiên đăng nhập còn xài dc tiếp không
    let context = store.state[ModuleContext];
    if (context) {
      let token = context.Token;

      //nếu chưa có thông tin token - kiểm tra localStorage
      if (!token) {
        token = commonFn.getLocalStorage("Token");
        if (token) {
          const user = JSON.parse(commonFn.getLocalStorage("User"));
          //kiểm tra nếu request lệch với phiên hiện tại của amis -> login lại
          if (
            (window._auid && window._auid !== user.AmisID) ||
            (window._atid && window._atid !== user.TenantID)
          ) {
            return false;
          }

          context.Token = token;
          context.TokenTimeout = parseInt(
            commonFn.getLocalStorage("TokenTimeout"),
            10
          );
          context.Context = JSON.parse(commonFn.getLocalStorage("Context"));
          context.User = user;
          // context.Permission = JSON.parse(
          //   commonFn.getLocalStorage("Permission")
          // );
          // context.Permission = JSON.parse(
          //   commonFn.getLocalStorage("Permission")
          // );
          // context.OrganizationUnit = JSON.parse(
          //   commonFn.getLocalStorage("OrganizationUnit")
          // );
          // let getting = commonFn.getLocalStorage("GettingStarted");
          // if (getting) {
          //   getting = JSON.parse(getting);
          //   context.GettingStarted = getting;
          // }
        }
      }

      if (token) {
        //init indexedDB
        indexedDB.init(context.Context.TenantID);

        if (
          !context.TokenTimeout ||
          new Date().getTime() <= context.TokenTimeout
        ) {
          return true;
        }
      }
    }

    // //xóa cache
    // store.dispatch([ModuleOrganizationUnit, "resetTreeCahe"].join("/"));

    return false;
  }

  /**
   * Lấy token
   */
  getToken() {
    let fn = [ModuleContext, "getToken"].join("/");
    return store.dispatch(fn);
  }

  /**
   * Kiểm tra đã getting chưa
   */
  isGetting() {
    try {
      let getting = window._getting;
      if (!getting) {
        getting = commonFn.getLocalStorage("GettingStarted");
        if (getting) {
          getting = JSON.parse(getting);
        }
      }
      return getting.GettingStarted;
    } catch (err) {
      console.error(err);
    }
    
    return false;
  }

  /**
   * Giải phóng tài nguyên phiên đăng nhập hiện tại
   */
  clearLoginData() {
    //xóa all sessionStorage
    sessionStorage.clear();
    
    //xóa các key của ams trong localStorage
    var prefix = window._appConfig.localStoragePrefix;
    if (prefix) {
      let lks = Object.keys(localStorage);
      if (Array.isArray(lks)) {
        lks.forEach(k => {
          if (k.indexOf(prefix) === 0) {
            localStorage.removeItem(k);
          }
        });
      }
    }    
  }
}

export default new AuthService();
